import {
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  Type,
  ViewChild,
} from '@angular/core';
import {ModalHostCompDirective} from 'src/app/directives/modal-host-comp.directive';
import {GfxMiscSrv} from 'src/app/services/gfx.misc.service';
import {ModalDismissReasons, NgbActiveModal,} from '@ng-bootstrap/ng-bootstrap';
import {SharingDataService} from 'src/app/services/sharing-data.service';

@Component({
  selector: "app-gfx-modal-host",
  templateUrl: "./gfx-modal-host.component.html",
  styleUrls: ["./gfx-modal-host.component.css"],
})
export class GfxModalHostComponent implements OnInit, OnDestroy {
  @ViewChild(ModalHostCompDirective, { static: true })
  appContentHost: ModalHostCompDirective;
  title: string;

  components = [
   
  ];
  modalEvent: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private misc: GfxMiscSrv,
    private activeModal: NgbActiveModal,
    private sharing: SharingDataService
  ) {}

  ngOnInit() {
    this.modalEvent = this.sharing.currentModalConfig.subscribe(
      (mdlConfig: any) => {
        if (mdlConfig) {
          this.title = mdlConfig.title;
          this.loadModalContent(mdlConfig.component);
          this.sharing.changeDataModal(mdlConfig.data);
        }
      }
    );
  }

  loadModalContent(cName: String) {
    if (!cName) {
      return;
    }

    let components = this.components.filter((x) => x.name == cName);
    let component: Type<any> = components.length
      ? components[0].component
      : null;

    if (!component) {
      this.misc.msgDialog(
        "Alerte",
        "le composant " + cName + " n'est pas enregistré ou n'existe pas"
      );
      return;
    }

    const appDynComponentFactoryClass = this.componentFactoryResolver.resolveComponentFactory(
      component
    );
    const viewContainerRef = this.appContentHost.viewContainerRef;
 
    if (viewContainerRef) {
      viewContainerRef.clear();
    }

    let componentRef = viewContainerRef.createComponent(
      appDynComponentFactoryClass
    );
  }

  public getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  close() {
    this.activeModal.close();
  }

  ngOnDestroy() {
    if (this.modalEvent) {
      this.modalEvent.unsubscribe();
    }
  }
}
